import { cards } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            今日必看
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            精选今日吃瓜最新爆料，热门内容不容错过
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(3, 5).map((item, i) => (
            <a
              key={i + 3}
              href="#cards"
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-[200px] aspect-[3/2] sm:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-2 self-start whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}